import { get } from 'helpers/api';
import { contactPersonFromApi, contactCompanyFromApi } from 'helpers/contacts/project_contact_api';

import { getProject } from '../selectors/index';

export const START_LOAD = 'contacts/START_LOAD';
export const startLoad = () => ({ type: START_LOAD });

export const LOAD_SUCCESS = 'contacts/LOAD_SUCCESS';
export const loadPeopleSuccess = people => (
  { type: LOAD_SUCCESS, payload: { people } }
);

export const loadCompaniesSuccess = companies => (
  { type: LOAD_SUCCESS, payload: { companies } }
);

export const LOAD_FAILURE = 'contacts/LOAD_FAILURE';
export const loadFailure = error => ({ type: LOAD_FAILURE, payload: { error } });

export const retrievePeople = () => {
  return async (dispatch, getState) => {
    const projectId = getProject(getState()).id;
    const path = `/projects/${projectId}/contact_roles.json`;

    dispatch(startLoad());
    try {
      const response = await get(path, { params: { type: 'person' } });
      const people = response.contactRoles.map(cr => contactPersonFromApi(cr));
      dispatch(loadPeopleSuccess(people));
    } catch (e) {
      dispatch(loadFailure(e.toString()));
    }
  };
};

export const retrieveCompanies = () => {
  return async (dispatch, getState) => {
    const projectId = getProject(getState()).id;
    const path = `/projects/${projectId}/contact_roles.json`;

    dispatch(startLoad());
    try {
      const response = await get(path, { params: { type: 'company' } });
      const companies = response.contactRoles.map(cr => contactCompanyFromApi(cr));
      dispatch(loadCompaniesSuccess(companies));
    } catch (e) {
      dispatch(loadFailure(e.toString()));
    }
  };
};
